module.exports = __webpack_public_path__ + "img/questionbankgray.a8eb668c.svg";